import { useMutation } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { useState } from "react";

import { AuthCard } from "@/components/auth-card";
import { FormField } from "@/components/form-field";
import { Alert } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { errorMessage, requestPasswordReset } from "@/lib/api";

/** `/passwort-vergessen` (AUTH-03): asks for a link by e-mail. */
export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const mutation = useMutation({ mutationFn: () => requestPasswordReset(email) });

  return (
    <AuthCard
      title="Passwort vergessen"
      description="Wir schicken dir einen Link, mit dem du ein neues Passwort setzt."
    >
      {mutation.isSuccess ? (
        <div className="grid gap-4">
          <Alert variant="success">
            Wenn es zu {email} ein Konto gibt, ist eine E-Mail mit einem Link unterwegs. Der Link
            gilt 60 Minuten.
          </Alert>
          <BackToLogin />
        </div>
      ) : (
        <form
          className="grid gap-4"
          onSubmit={(e) => {
            e.preventDefault();
            mutation.mutate();
          }}
        >
          {mutation.isError && <Alert variant="destructive">{errorMessage(mutation.error)}</Alert>}
          <FormField
            label="E-Mail"
            type="email"
            autoComplete="username"
            required
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button type="submit" disabled={mutation.isPending}>
            Link schicken
          </Button>
          <BackToLogin />
        </form>
      )}
    </AuthCard>
  );
}

export function BackToLogin() {
  return (
    <Link
      to="/anmelden"
      className="text-center text-sm text-muted-foreground underline-offset-4 hover:underline"
    >
      Zur Anmeldung
    </Link>
  );
}
